
import React from 'react';
import { useSelector } from 'react-redux';
import Loader from ".././component/loader";
const LoaderGlobal = () => {
    const loader = useSelector((state) => state.loader)
  return (
    <>
    {/* Other components */}
    {loader && <Loader />} {/* Render loader based on state */}
      {/* Rest of your application */}
    </>
  )
}

export default LoaderGlobal
